<div class="error pl-4 pb-4" [class.is-full-width]="isFullWidth">When two terms are specified, the first must precede (or equal) the second</div>
